module.exports = __webpack_public_path__ + "img/br-flag.7bf8009c.png";